import React, { Component } from 'react';
import { Form, Icon, Input } from 'semantic-ui-react';
import { onlyAllowNumericAndLettersInput } from '../../../constants/keyPressEvents';

class ReturnBookScanForm extends Component {
    state = { returnBookSerial: '' };

    constructor(props) {
        super(props);
        this.scannerField = React.createRef();
    }

    handleScanChange = (event, { value }) => {
        this.setState({ returnBookSerial: value });
    };

    handleScanKeyDown = async (event) => {
        if (event.key === 'Enter') {
            const { onSubmit } = this.props;
            const { returnBookSerial } = this.state;

            if (returnBookSerial) {
                if (onSubmit) {
                    await onSubmit({ returnBookSerial });
                    this.clearScannerField();
                }
            }
        }
    };

    handleClearSearchClick = () => {
        this.clearScannerField();
    };

    clearScannerField() {
        this.setState({ returnBookSerial: '' });
        this.scannerField && this.scannerField.current.select();
    }

    render() {
        const { processing } = this.props;
        const { returnBookSerial } = this.state;

        const searchIcon = (
            <Icon name="close" link onClick={this.handleClearSearchClick} />
        );

        return (
            <Form loading={processing}>
                <Form.Field>
                    <Input
                        name="returnBookSerial"
                        fluid
                        placeholder="Pack No."
                        className="bg-transparent pending-return-input"
                        onKeyPress={onlyAllowNumericAndLettersInput}
                        onKeyDown={(event) => this.handleScanKeyDown(event)}
                        onChange={this.handleScanChange}
                        icon={searchIcon}
                        ref={this.scannerField}
                        value={returnBookSerial}
                        autoFocus
                        disabled={processing}
                    />
                </Form.Field>
            </Form>
        );
    }
}

export default ReturnBookScanForm;
